/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export default class Step00View extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {}
    }

    searchAddressType = (addressTypeKey: any) => {

        /**
         * Set address type list
         */
        const addressTypeList = [
            { value: 'home', text: 'Home' },
            { value: 'office', text: 'Office' },
            { value: 'storage', text: 'Storage' },
            { value: 'retail', text: 'Retail' },
        ]

        for (var i = 0; i < addressTypeList.length; i++) {
            if (addressTypeList[i].value === addressTypeKey) {
                return addressTypeList[i].text
            }
        }

        return true
    }

    render() {

        /**
         * Set client type list
         */
        const clientTypeList = [
            { value: 'individual', text: 'Individual' },
            { value: 'limited-company', text: 'Limited Company' },
            { value: 'sole-trader', text: 'Other Entity' },
        ]

        return (
            <div className="step00">
                <div className="quote__form">
                    <h4>Policy type</h4>

                    <div className="quote__form__group form__w40">
                        <label className="active">Policy type</label>
                        <div className="quote__form__inputView">
                            {this.props.values.quote.policyName}
                        </div>
                    </div>

                    <div className="quote__form__splitter" />

                    <h4>Client Details</h4>

                    <div className="quote__form__group form__w40">
                        <label className="active">Client type</label>
                        <div className="quote__form__inputView">
                            {clientTypeList[this.props.values.client.clientType].text}
                        </div>
                    </div>

                    <div className="quote__form__group form__w60">
                        <label className="active">Business Name</label>
                        <div className="quote__form__inputView">
                            {this.props.values.client.businessName}
                        </div>
                    </div>

                    <div className="quote__form__splitter" />

                    <h4>Client’s full name</h4>

                    <div className="quote__form__group form__w100">
                        <label className="active">Client name</label>
                        {this.props.values.client.clientNames.map( (client, i) => (
                            <div className="quote__form__inputView" key={i}>
                                {client.title} {client.firstName} {client.surname}
                            </div>
                        ))}
                    </div>

                    <div className="quote__form__splitter" />

                    <h4>Address</h4>

                    <div className="quote__form__group form__w100">
                        <label className="active">Address type</label>
                        <div className="quote__form__inputView">
                            {this.searchAddressType(this.props.values.client.addressType)}
                        </div>
                    </div>

                    <div className="quote__form__group form__w50">
                        <label className="active">Address line 1</label>
                        <div className="quote__form__inputView">
                            {this.props.values.client.addressLine1}
                        </div>
                    </div>

                    <div className="quote__form__group form__w50">
                        <label className="active">Address line 2</label>
                        <div className="quote__form__inputView">
                            {this.props.values.client.addressLine2}
                        </div>
                    </div>

                    <div className="quote__form__group form__w50">
                        <label className="active">Town/City</label>
                        <div className="quote__form__inputView">
                            {this.props.values.client.city}
                        </div>
                    </div>

                    <div className="quote__form__group form__w50">
                        <label className="active">Postcode</label>
                        <div className="quote__form__inputView">
                            {this.props.values.client.postcode}
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/EditQuote/components/Step00View.tsx